import { SystemInsightsModel } from '../models/SystemInsights.model';
import { UserInsightsModel } from '../models/UserInsights.model';

export type ChartDataType<T extends string | number> = {
  label: string;
  value: T;
};

export enum AnalyticTypes {
  USER = 'USER',
  CONTENT = 'CONTENT',
  NOTIFICATION = 'NOTIFICATION',
  GUEST = 'GUEST',
}

export enum ExtendedAnalyticTypes {
  USER = 'USER',
  CONTENT = 'CONTENT',
  NOTIFICATION = 'NOTIFICATION',
  GUEST = 'GUEST',
  UPGRADE = 'UPGRADE',
  GUEST_CONTENT = 'GUEST_CONTENT',
  GUEST_NOTIFICATION = 'GUEST_NOTIFICATION',
}

export enum UserExtendedAnalyticTypes {
  USER = 'USER',
  CONTENT = 'CONTENT',
  NOTIFICATION = 'NOTIFICATION',
  GUEST = 'GUEST',
  UPGRADE = 'UPGRADE',
}

export enum PostTypeTypes {
  NewsItem = 'NewsItem',
  JobItem = 'JobItem',
  EventItem = 'EventItem',
  FormItem = 'FormItem',
  DocumentItem = 'DocumentItem',
}

export type PostTypeFilter = keyof typeof PostTypeTypes | 'All';

export enum InsightsFilter {
  WEEKLY = 'WEEKLY',
  ALL_TIME = 'ALL_TIME',
}

export type InsightsRequest = {
  filter: InsightsFilter;
};

export interface SystemInsightResponseDTO {
  data: SystemInsightsModel;
}

export interface UserInsightResponseDTO {
  data: UserInsightsModel;
}
